/* eslint-disable max-len */
import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const HelpCenterSvg = styled.svg`
  width: ${prop('size', 36)}px;
  height: ${prop('size', 36)}px;
  :hover {
    .a,
    .c {
      fill: ${prop('hoverColor', colorsOptions.greys['grey-100'])};
    }
  }
  .a,
  .c {
    fill: ${prop('color', colorsOptions.greys['grey-100'])};
  }
`

function HelpCenterIcon ({ color, hoverColor, size, ...props }) {
  return (
    <HelpCenterSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect className="a" width="32" height="32" />
        </clipPath>
      </defs>
      <g className="b">
        <path
          className="c"
          d="M31.482,13.3a1.657,1.657,0,0,0-.875-.425,14.257,14.257,0,0,0-.406-1.557,6.9,6.9,0,0,0,.705-3.039,7,7,0,0,0-7-7,6.906,6.906,0,0,0-2.881.631,14.8,14.8,0,0,0-1.909-.541A1.635,1.635,0,0,0,17.5,0h-3a1.639,1.639,0,0,0-1.621,1.385,14.324,14.324,0,0,0-1.9.532,6.92,6.92,0,0,0-2.885-.631,7,7,0,0,0-7,7A6.9,6.9,0,0,0,1.8,11.321a14.63,14.63,0,0,0-.409,1.557,1.672,1.672,0,0,0-.873.424A1.647,1.647,0,0,0,0,14.5v3a1.633,1.633,0,0,0,1.393,1.621,14.125,14.125,0,0,0,.405,1.56,6.892,6.892,0,0,0-.705,3.037,7,7,0,0,0,7,7,6.887,6.887,0,0,0,2.879-.633,14.942,14.942,0,0,0,1.909.531A1.638,1.638,0,0,0,14.5,32h3a1.636,1.636,0,0,0,1.621-1.383,14.447,14.447,0,0,0,1.9-.533,6.913,6.913,0,0,0,2.885.631,7,7,0,0,0,7-7,6.912,6.912,0,0,0-.7-3.043,14.381,14.381,0,0,0,.407-1.555A1.633,1.633,0,0,0,32,17.5v-3a1.647,1.647,0,0,0-.518-1.2M23.91,2.255a6.033,6.033,0,0,1,6.026,6.027,5.875,5.875,0,0,1-.254,1.691,15.047,15.047,0,0,0-7.325-7.505,5.943,5.943,0,0,1,1.553-.212M29.616,12.9l-4.4.269a9.673,9.673,0,0,0-6.381-6.374L19.1,2.377A14.007,14.007,0,0,1,29.616,12.9m-5.388,5.8a8.708,8.708,0,0,1-5.521,5.542,1.643,1.643,0,0,0-1.547-1.107H14.839a1.643,1.643,0,0,0-1.543,1.1,8.709,8.709,0,0,1-5.541-5.525A1.642,1.642,0,0,0,8.864,17.16V14.841a1.642,1.642,0,0,0-1.1-1.543A8.7,8.7,0,0,1,13.3,7.765a1.644,1.644,0,0,0,1.544,1.1H17.16a1.641,1.641,0,0,0,1.542-1.1,8.707,8.707,0,0,1,5.537,5.526,1.644,1.644,0,0,0-1.1,1.546V17.16A1.642,1.642,0,0,0,24.228,18.7M14.007,1.183A.669.669,0,0,1,14.5.97h3a.674.674,0,0,1,.673.715l-.34,5.577a.677.677,0,0,1-.674.633H14.839a.676.676,0,0,1-.673-.633l-.341-5.577a.669.669,0,0,1,.182-.5M12.9,2.378l.27,4.415A9.668,9.668,0,0,0,6.8,13.167L2.374,12.9A14.012,14.012,0,0,1,12.9,2.378M8.089,2.255a5.906,5.906,0,0,1,1.553.213,15.044,15.044,0,0,0-7.324,7.5,5.851,5.851,0,0,1-.255-1.69A6.033,6.033,0,0,1,8.089,2.255M.969,17.5v-3a.675.675,0,0,1,.673-.675h.043l5.576.341a.676.676,0,0,1,.633.673V17.16a.676.676,0,0,1-.633.673l-5.576.341A.675.675,0,0,1,.969,17.5m7.12,12.245a6.033,6.033,0,0,1-6.026-6.027,5.932,5.932,0,0,1,.254-1.691,15.047,15.047,0,0,0,7.323,7.5,5.9,5.9,0,0,1-1.551.213M2.383,19.1l4.4-.269A9.677,9.677,0,0,0,13.167,25.2L12.9,29.625A14.009,14.009,0,0,1,2.383,19.1M17.992,30.819a.669.669,0,0,1-.491.212h-3a.675.675,0,0,1-.674-.716l.341-5.577a.676.676,0,0,1,.673-.633H17.16a.676.676,0,0,1,.674.633l.34,5.577a.671.671,0,0,1-.182.5m1.111-1.2-.269-4.4A9.676,9.676,0,0,0,25.2,18.833l4.427.27A14.006,14.006,0,0,1,19.1,29.615m4.807.13a5.876,5.876,0,0,1-1.548-.215,15.043,15.043,0,0,0,7.319-7.5,5.9,5.9,0,0,1,.255,1.69,6.033,6.033,0,0,1-6.026,6.027M31.03,17.5a.675.675,0,0,1-.716.674l-5.576-.341a.676.676,0,0,1-.633-.673V14.841a.675.675,0,0,1,.633-.673l5.576-.341a.674.674,0,0,1,.716.673Z"
        />
      </g>
    </HelpCenterSvg>
  )
}

HelpCenterIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number
}

export default HelpCenterIcon
